import request from '@/api/http.js'

// 列出系统支持所有的权限
export function permissions(query) {
    return request({
        url: 'permissions',
        method: 'get',
        params: query,
    })
}

export function getDivsList(query) {
    return request({
        url: 'divs',
        method: 'get',
        params: query,
    })
}
export function getDivList(query) {
    return request({
        url: 'div',
        method: 'get',
        params: query,
    })
}

//查询绩效列表
export function getPerformanceList(query) {
    return request({
        url: 'div/attachments',
        method: 'get',
        params: query,
    })
}

export function tongyi(params) {
    return request({
        method: 'post',
        url: 'div/tongyi',
        data: params,
    })
}
export function tuihui(params) {
    return request({
        method: 'post',
        url: 'div/tuihui',
        data: params,
    })
}
export function fabu(params) {
    return request({
        method: 'post',
        url: '/div/fabu',
        data: params,
    })
}
//导入单位列表
export function importDiv(params) {
    return request({
        method: 'post',
        url: 'divs/importDiv',
        data: params,
    })
}

//导入科室列表
export function importKs(params) {
    return request({
        method: 'post',
        url: 'divs/importKs',
        data: params,
    })
}

//收回
export function shouhui(params) {
    return request({
        method: 'post',
        url: 'div/shouhui',
        data: params,
    })
}

//div/log
export function log(query) {
    return request({
        method: 'get',
        url: '/log',
        params: query,
    })
}

//上传
export function songshen(params) {
    return request({
        method: 'post',
        url: 'div/songshen',
        data: params,
        responseType : 'text'
    })
}

//后台返回pdf
export function Preview(params) {
    return request({
        method: 'get',
        url: 'div/pdf',
        data: params,
        responseType: 'blob'
    })
}

//保存情况说明
export function editQksm(params) {
    return request({
        method: 'post',
        url: 'div/qksm',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        },
    })
}
//查询情况说明
export function selectQksm(query) {
    return request({
        url: 'div/qksms',
        method: 'get',
        params: query,
    })
}
//下载pdf文件
export function downLoadpdf(query) {
    return request({
        url: `div/pdf/${query.name}.pdf`,
        method: 'get',
        params: query,
        responseType: 'blob',
        timeout:2 * 60000
    })
}

//下载word文件
export function downLoadword(params) {
    return request({
        url: `div/docx`,
        method: 'post',
        params: params,
        responseType: 'blob'
    })
}
//获取科目本
export function getKemuQuery(query) {
    return request({
        url: 'kemu/query',
        method: 'get',
        params: query,
    })
}
// 单位复制部门的情况说明
export function qksmCopyFrom(params) {
    return request({
        method: 'post',
        url: 'div/qksmCopyFrom',
        data: params,
    })
}
export function fixData(params) {
    return request({
        method: 'post',
        url: '/div/queren',
        data: params,
    })
}
//下载原始导入文件
export function downloadRaw(params) {
    return request({
        method: 'get',
        url: '/div/downloadRaw',
        params: params,
        responseType: 'blob',
    })
}
//下载docx
export function docxDownload(params) {
    return request({
        method: 'get',
        url: '/div/docx',
        params: params,
        responseType: 'blob',
    })
}


